<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header title="Mentora Class Schedule"
                        :isNewButton="checkPermission('session_store')"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile title="Mentora Class Schedule"
                              :isNewButton="checkPermission('session_store')"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :exportExcel="checkPermission('session_delete')"
                @exportExcel="exportExcel"
            >
                <b-row>
                    <b-col sm="4">
                        <b-form-group :label="$t('day_part')">
                            <ParameterSelectbox
                                v-model="datatable.queryParams.filter.day_part" code="session_day_parts" sort="code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('day_type')">
                            <ParameterSelectbox
                                v-model="datatable.queryParams.filter.day_type" code="session_day_types" sort="code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('module_date')">
                            <module-date-selectbox ref="moduleDate" v-model="datatable.queryParams.filter.module_date_id">
                            </module-date-selectbox>
                        </b-form-group>
                    </b-col>
                  <b-col sm="4">
                    <b-form-group :label="$t('program')">
                      <program-selectbox level="E" v-model="datatable.queryParams.filter.program_code"></program-selectbox>
                    </b-form-group>
                  </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('course')">
                          <esl-course-selectbox v-model="datatable.queryParams.filter.course_id"></esl-course-selectbox>
                        </b-form-group>
                    </b-col>
                  <b-col sm="4">
                    <b-form-group :label="$t('section')">
                      <b-form-input type="number" v-model="datatable.queryParams.filter.section">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('days_of_the_week')">
                            <ParameterSelectbox
                                v-model="datatable.queryParams.filter.days_of_the_week" :multiple="true" code="days" sort="code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.start_date"></select-date>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="datatable.queryParams.filter.end_date">
                            </select-date>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input type="time" v-model="datatable.queryParams.filter.start_time">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input type="time" v-model="datatable.queryParams.filter.end_time">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('evaluation')">
                            <evaluation-selectbox v-model="datatable.queryParams.filter.evaluation_id"></evaluation-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('classroom')">
                            <classroom-selectbox v-model="datatable.queryParams.filter.classroom_id" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete v-model="datatable.queryParams.filter.instructor_id" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('session_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('session_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess==='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('session_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess==='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="sessionOverviewModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('overview') }}
                </template>
                <template v-slot:CommonModalContent>
                    <SessionOverview :form-id="formId" :selectedSession="selectedSession" v-if="formProcess==='session_overview'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    import EvaluationSelectbox from "@/components/interactive-fields/EvaluationSelectbox.vue";
    import EslCourseSelectbox from "@/components/interactive-fields/EslCourseSelectbox.vue";
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";
    import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";

    //Other
    import qs from "qs";
    //Service
    import SessionService from "@/services/SessionService";
    //Page
    import CreateForm from "./CreateForm"
    import UpdateForm from "./UpdateForm"
    import ShowForm from "./ShowForm"
    import SessionOverview from "@/modules/session/pages/SessionOverview.vue";
    import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
    import showErrors from "@/helpers/showErrors";

    export default {
        components: {
            ModuleDateSelectbox,
            SessionOverview,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm,
            ShowForm,

            EvaluationSelectbox,
            EslCourseSelectbox,
            ParameterSelectbox,
            ClassroomSelectbox,
            StaffAutoComplete
        },
        metaInfo() {
            return {
                title: "Mentora Class Schedule",
            };
        },
        data() {
            return {
                selectCode: null,
                selectedSession:null,
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t("edit"),
                                    class: "ri-edit-box-line",
                                    permission: 'session_update',
                                    callback: (row) => {
                                        this.loadData(row.id);
                                    },
                                },
                                {
                                    text: this.$t("delete"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'session_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                },
                                {
                                    text: this.$t("success_report"),
                                    class: "ri-upload-line",
                                    callback: (row) => {
                                        this.sessionSuccessReport(row);
                                    },
                                },
                           /*     {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'session_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },*/
                                {
                                    text: this.$t('daily_attendance'),
                                    class: 'ri-calendar-check-line',
                                    permission: 'eslattendance_store',
                                    callback:(row)=>{
                                        window.open('/esl/attendance/' + row.id, '_blank')
                                    }
                                },
                                {
                                    text: this.$t('daily_attendance_admin'),
                                    class: 'ri-calendar-check-line',
                                    permission: 'eslattendance_storeadmin',
                                    callback:(row)=>{
                                        window.open('/esl/attendance/admin/' + row.id, '_blank')
                                    }
                                },
                                {
                                    text: this.$t("attendance_tracking"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'eslattendance_attendancereport',
                                    callback: (row) => {
                                        this.attendanceReport(row);
                                    },
                                },
                                {
                                    text: this.$t("overview"),
                                    class: "ri-file-list-line",
                                    permission: 'studentsession_index',
                                    callback: (row) => {
                                        this.showOverview(row);
                                    },
                                },
                                {
                                    text: this.$t('assessment'),
                                    class: 'ri-clipboard-line',
                                    permission: 'assessment_assessmentscoreupdateorcreate',
                                    callback:(row)=>{
                                        window.open('/assessment/bulk/entry/' + row.id, '_blank')
                                    }
                                },
                            ],
                        },
                        {
                            label: this.$t("id"),
                            field: "id",
                            sortable: true,
                            hidden: true
                        },
                        {
                            label: this.$t("day_part"),
                            field: "day_part",
                            sortable: true,
                        },
                        {
                            label: this.$t("day_type"),
                            field: "day_type",
                            sortable: true,
                        },
                        {
                            label: this.toUpperCase('days_of_the_week'),
                            field: 'days_of_the_week',
                            hidden: false,
                            sortable: false,
                            formatFn: (row) => {
                                let dayName=[];
                                row.forEach(item => {
                                    dayName.push(this.selectDay(item));
                                })
                                return Array.isArray(dayName) ? dayName.join(', ') : dayName;
                            }
                        },
                        {
                            label: this.$t("course"),
                            field: "course_name",
                            sortable: false,
                        },
                        {
                          label: this.$t("section"),
                          field: "section",
                          sortable: false,
                        },
                        {
                            label: this.$t("start_date"),
                            field: "start_date",
                            sortable: true,
                        },
                        {
                            label: this.$t("end_date"),
                            field: "end_date",
                            sortable: true,
                        },
                        {
                            label: this.$t("start_time"),
                            field: "start_time",
                            sortable: true,
                        },
                        {
                            label: this.$t("end_time"),
                            field: "end_time",
                            sortable: true,
                        },
                        {
                            label: this.$t("evaluation"),
                            field: "evaluation_name",
                            sortable: false,
                        },
                        {
                            label: this.$t("classroom"),
                            field: "classroom_name",
                            sortable: false,
                        },
                        {
                            label: this.$t("teaching_staff"),
                            field: "instructor_id",
                            sortable: false,
                            formatFn: (value, row) => {
                                return row.instructor_name + ' ' + row.instructor_surname
                            },
                        },
                        {
                            label: this.$t("quota"),
                            field: "quota",
                            sortable: true,
                        },
                        {
                            label: this.$t("class_modality"),
                            field: "class_modality",
                            sortable: true,
                        },
                        {
                            label: this.$t("number_of_students_pre_registered"),
                            field: "students_count",
                            sortable: false,
                        },
                        {
                            label: this.$t("fully_enrolled_students"),
                            field: "fully_students_count",
                            sortable: false,
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "days_of_the_week,course_name",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return SessionService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;

                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData(id) {
                this.formProcess = "update";
                this.formId = id;
                SessionService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.$swal
                  .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      SessionService.del(id)
                          .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message))
                            this.getRows()
                          })
                          .catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message))
                          })
                    }
                  })
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            showOverview(row) {
                this.formId = row.id
                this.selectedSession = row
                this.formProcess = 'session_overview'
                this.$refs.sessionOverviewModal.$refs.commonModal.show()
            },
            sessionSuccessReport(row) {
                const config = {
                    params: {
                       response_type: "excel"
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };
                return SessionService.sessionSuccessReport(config, row.id)
                    .then((response) => {
                        this._downloadFile(response, row.course_name+' - '+row.start_date + ' - Class Success Report.xlsx')
                    }).catch(err =>showErrors(err))
            },
            attendanceReport(row) {
                const config = {
                    params: {
                        response_type: "excel"
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };
                config.responseType = 'arraybuffer';
                return SessionService.downloadReportSession(config, row.id)
                    .then((response) => {
                        this._downloadFile(response, row.course_name+' - '+row.start_date + ' - Attendance Report.xlsx')
                    }).catch(err =>{
                        this.showErrors(err,null,true)
                    })
            },
            exportExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                SessionService.exportExcelSession(config).then(res => this._downloadFile(res, this.$t('sessions') + '.xlsx')).catch(err => this.showErrors(err))
            }
        },
    };
</script>

